import { User } from '@prisma/client'
import { Form, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { FeatureFormConfigurationClient } from '~/features/formConfiguration/client'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = {
  user: User
} & StepProps

export const StepDaily: React.FC<Props> = ({ user, ...props }) => {
  const configuration = { timezone: user.timezone }

  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>How do you want to work with me?</TitlePrimary>

        <Typography.Text className="mb-10">
          ✨ Everyday, I'll suggest new article ideas based on the content
          currently on your website.
        </Typography.Text>

        <Form.Item
          name={['article', 'rule']}
          label="Pick a time for me to send you blog article ideas"
          getValueFromEvent={items => items[0]}
        >
          <FeatureFormConfigurationClient.RRulePicker
            type="DAILY"
            formValuesConfiguration={configuration}
          />
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
